import { render, staticRenderFns } from "./p24.vue?vue&type=template&id=7ea883a8"
import script from "./p24.vue?vue&type=script&lang=js"
export * from "./p24.vue?vue&type=script&lang=js"
import style0 from "./p24.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports